module.exports = __webpack_public_path__ + "img/app-store-logo.ff071979.png";